import MeetingConfigBlock from './MeetingConfigBlock'

export default MeetingConfigBlock
